
/**
* 用工中心 导出列表
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/task/professionalList' }"
        >自由职业者列表</el-breadcrumb-item
      >
      <el-breadcrumb-item>导入记录</el-breadcrumb-item>
    </el-breadcrumb>
    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      element-loading-text="拼命加载中"
      style="width: 100%; margin-top: 20px"
    >
      <el-table-column prop="id" label="记录Id"> </el-table-column>
      <el-table-column prop="status" label="状态" show-overflow-tooltip>
        <template slot-scope="scope">
          <span :style="{ color: getStatusColor(scope.row.status) }">
            {{ getStatusText(scope.row.status) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="process" label="进度" show-overflow-tooltip>
        <template slot-scope="scope">
          <div class="progress-container">
            <el-progress
              :percentage="calcProgress(scope.row)"
              :status="getProgressStatus(scope.row)"
              :stroke-width="14"
              :text-inside="true"
            ></el-progress>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="typeStr" label="导入类型" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="totalNum" label="导入数量" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="successNum" label="成功数量" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="failedNum" label="失败数量" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="detail" label="详情" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-link type="primary" @click="viewLogDtl(scope.row.id)"
            >查看</el-link
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAtStr"
        label="导入时间"
        show-overflow-tooltip
      >
      </el-table-column>

      <el-table-column prop="remark" label="备注" show-overflow-tooltip>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
  </div>
</template>

<script>
import { importContractLogs } from "../../api/userMG";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      fileList: [],
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      title: "添加",

      // rules表单验证
      rules: {},
      formInline: {
        status: "",
        page: 1,
        pageSize: 10,
      },
      // 删除部门

      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
      multipleSelection: [],
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline);
  },

  methods: {
    calcProgress(row) {
      const total = row.totalNum || 0;
      if (total === 0) return 0; // 避免除以0
      const processed = (row.successNum || 0) + (row.failedNum || 0);
      return Math.round((processed / total) * 100); // 四舍五入取整
    },

    getProgressStatus(row) {
      const progress = this.calcProgress(row);
      // 完成状态（100%）且状态为“完成”时显示成功色
      if (progress === 100 && row.status === 2) return "success";
      // 失败状态且进度未完成时显示警告色
      if (row.status === 3 && progress < 100) return "exception";
      // 其他情况（待处理、处理中）显示默认色
      return "";
    },
    // 获取状态文本
    getStatusText(status) {
      const statusMap = {
        0: "待处理",
        1: "处理中",
        2: "完成",
        3: "失败",
      };
      return statusMap[status] || "未知";
    },

    // 获取状态对应的颜色
    getStatusColor(status) {
      const colorMap = {
        0: "#409EFF", // 待处理：蓝色
        1: "#409EFF", // 处理中：蓝色
        2: "#67c23a", // 完成：绿色
        3: "#f56c6c", // 失败：红色
      };
      return colorMap[status] || "#909399"; // 默认灰色
    },

    getdata(parameter) {
      this.loading = true;
      importContractLogs(parameter)
        .then((res) => {
          this.loading = false;
          if (res.msg != "success") {
            this.$message({
              type: "error",
              message: res.msg,
            });
          } else {
            this.listData = res.data.items;
            // 分页赋值
            this.pageparm.page = res.data.page;
            this.pageparm.pageSize = res.data.pageSize;
            this.pageparm.total = res.data.totalCount;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },

    viewLogDtl(id) {
      this.$router.push({
        path: "/task/contractMigrationLogDtl",
        query: {
          id: id,
        },
      });
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #fff;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.userRole {
  width: 100%;
}
/* .progress-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px; 
}


.progress-text {
  font-size: 12px;
  color: #606266;
} */
</style>





// WEBPACK FOOTER //
// src/views/task/contractMigrationLog.vue